<template>
  <div>
    <!-- Список тестов -->
    <div
      id="tests-list"
      class="d-flex flex-column pb-2"
      :style="!mobile ? `height:${clientH - 110}px` : ''"
      v-if="view === 1"
    >
      <v-card
        v-for="(item, key) in list"
        :key="'A' + key"
        class="mx-2 my-2"
        elevation="2"
      >
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" sm="12" md="7">
              <p class="text--primary mb-0" :class="!mobile ? 'text-h5' : 'body-1'">{{ item.bodySystemName }}</p>
            </v-col>
            <v-col cols="12" sm="12" md="5" :align="!mobile ? 'end' : 'start'">
              <v-btn :disabled="item.passingsCount === 0" @click="openResultTest(item)" class="mr-2" :x-large="!mobile" :default="mobile" depressed color="primary">Результаты теста</v-btn>
              <v-btn :loading="item.loading" @click="startTest(2, item)" :x-large="!mobile" :default="mobile" depressed color="primary">Пройти тест</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>

    <!-- Прохождение теста -->
    <div v-if="view === 2">
        <v-btn v-if="!mobile" class="mt-3 btn-back" @click="backToList(1)" color="blue darken-2" dark elevation="2" title="Вернутся к списку тестов">
            <v-icon>mdi-arrow-left</v-icon>
			Список тестов
        </v-btn>
        <v-row v-else class="mt-1">
            <v-col cols="7">
                <v-btn class="btn-back" @click="backToList(1)" color="blue darken-2" dark elevation="2" title="Вернутся к списку тестов">
                    <v-icon>mdi-arrow-left</v-icon>
                    Список тестов
                </v-btn>
            </v-col>
            <v-col cols="5">
                <div class="question-number">
                    <span>
                        Вопрос {{ questionNumber }} из {{ testObj.questions.length }}
                    </span>
                </div>
            </v-col>
        </v-row>
        
        <generalQuestion v-on:closeTest="closeTestF" :apiUrl="apiUrl" :testObj="testObj" v-on:nextQuestion="questionNumber += 1" />
    </div>
    
    <v-dialog v-model="dialog" max-width="1100px" persistent>
        <v-card>
            <v-toolbar dark color="#001e46">
                <v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
                    Результаты теста "{{ systemName }}"
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-items>
                    <v-btn icon color="rgba(129, 182, 228, 0.95)" @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pb-0">
                <v-container>
                    <result-test v-if="dialog" :idTest="idTest" :apiUrl="apiUrl" />
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.flag" top rounded="pill" elevation="24" :color="snackbar.color">
        <v-icon>mdi-information</v-icon>
        {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import generalQuestion from "./additionally/generalQuestion.vue";
import { mapGetters, mapMutations } from 'vuex'
import resultTest from './additionally/resultTest.vue'

export default {
    props: {
        clientH: {
        type: Number,
        default: () => 0,
        },
    },
    components: {
        generalQuestion,
        resultTest
    },
	computed: {
		...mapGetters({
            apiUrl: 'apiUrl',
            getActivatedTest: 'tests/getActivatedTest'
        })
	},
    data: () => ({
        systemName: '',
        idTest: null,
        dialog: false,
        view: 1,
		anketId: null,
        list: [],
        testObj: {},
        questionNumber: 1,
		snackbar: {
			flag: false,
			text: '',
			color: ''
		},
        mobile: false
    }),
	methods: {
        ...mapMutations({
            changeActivatedTest: 'tests/changeActivatedTest'
        }),
		startTest(view, item) {
            item.loading = true;

            this.$http.get(`${this.apiUrl}TestTask/GetRandom?id=${item.id}`)
            .then((res) => {
                this.testObj = res.data;
                item.loading = false;
			    this.view = view;

                this.changeActivatedTest(true);
            })
		},
        openResultTest(item) {
            this.systemName = item.bodySystemName
            this.idTest = item.id;
            this.dialog = true;
        },
        closeTestF(flag) {
            this.get();
            if(flag) {
                this.snackbar.flag = true;
                this.snackbar.text = 'Результат теста успешно сохранен!';
                this.snackbar.color = 'success';
            }
            this.view = 1
            this.changeActivatedTest(false);
        },
        get() {
            let params = {
                filters: [],
                sortOption: {
                    fieldName: 'title',
                    sortType: 2
                },
                pageSize: 1000,
                currentPage: 0,
                useANDoperator: false,
                columns: []
            };

            this.$http.post(`${this.apiUrl}TestTask/GetPublished`, params)
                .then((res) => {
                    this.list = res.data.data;

                    for (let i = 0; i < this.list.length; i++) {
                        this.list[i].loading = false;
                    }
                })
        },
        backToList(e) {
            if(this.getActivatedTest) {
                if(confirm('Вы уверены, что хотите выйти из теста? Ваши ответы не сохранятся!')) {
                    this.changeActivatedTest(false);
                    this.view = e
                }
            } else {
                this.view = e
            }
        }
	},
	created() {
		this.get();

        this.mobile = window.document.documentElement.clientWidth <= 960;
	}
};
</script>

<style scoped>
.btn-back {
    position: absolute;
	left: 6%;
    top: 9.5%;
}

@media screen and (max-width: 960px) {
    #tests-list {
        height: calc(100vh - 48px - 48px);
        overflow: auto;
    }
    .btn-back {
        position: static;
        margin-left: 16px;
    }
}

@media screen and (max-width: 432px) {
    .btn-back.v-size--default {
        padding: 5px 10px;
    }

    .question-number {
        color: #fff;
        height: 100%;
        margin-right: 16px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}
</style>